import { useState, useEffect } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import MainLanguageAutocomplete from '@/component/common/language/MainLanguageAutocomplete';

const AddUserRow = ({
    currentAddList,
    userList,
    userAddDetail,
    currentIndex,
    updateUserAddDetail,
    onDeleteOrShowModalUser,
    errorAddList
}) => {
    // Re-render when the translation dictionary loads/extends so tr() placeholders update.
    useTranslationSubscription();

    const [currentUser, setCurrentUser] = useState({});
    const [error, setError] = useState({});

    useEffect(() => {
        setCurrentUser(userAddDetail);
    }, [userAddDetail]);


    const validatedEmail = (email, userAddList, currentUserList, userId) => {
        let errors = ''
        if (Utils.isEmptyString(email.trim())) {
            errors = trI18n('COMMSG014');
        } else if (!Utils.validateEmail(email.trim())) {
            errors = trI18n('COMM01MSG07');
        } else if (email.trim().length > Constant.EMAIL_MAX_LENGTH) {
            errors = trI18n('COMMSG027').replace('{{maxLength}}', Constant.EMAIL_MAX_LENGTH);
        } else if (email.trim().length < 4) {
            errors = trI18n('COMMSG026').replace('{{minLength}}', 4);
        } else {
            const currentEmail = email.trim().toLowerCase();
            let isExistEmail = userAddList.filter(x => x.mailAddress.trim().toLowerCase() === currentEmail && x.id !== userId);
            if (isExistEmail && isExistEmail.length > 0) {
                return trI18n('USER09MSG007');
            } 
        }
    
        return errors;
    };

    const handleSelectChangeAdminOfAddUser = () => {
        let currentUserClone = cloneDeep(currentUser);

        const admin = [Constant.PRIVILEGE_USER.ADMIN_OWNER, Constant.PRIVILEGE_USER.ADMIN].includes(currentUserClone.privilege) ? Constant.ADMIN.OFF : Constant.ADMIN.ON;
        currentUserClone.isChangePermission = currentUserClone.isChangePermission === undefined ? true  : !currentUserClone.isChangePermission;
        currentUserClone.privilege = Constant.ADMIN.ON === admin ? Constant.PRIVILEGE_USER.ADMIN : '';

        setCurrentUser(currentUserClone);
        updateUserAddDetail(currentIndex, currentUserClone, error);
    };

    const validatedNameUser = name => {
        let errors = ''
        if (Utils.isEmptyString(name.trim())) {
            errors = trI18n('COMMSG014');
        } else if (name.trim().length > 200) {
            errors = trI18n('COMMSG027').replace('{{maxLength}}', '200');
        } else {
            errors = '';
        }
    
        return errors;
    };

    
    const handleOnChange = (e, type) => {
        let cloneCurrentUser = {...currentUser};
        let errorsRow = {...error};
        let errors = '';
        const currentUserList = cloneDeep(userList);
        const inputValue = e.target.value;
        const userId = cloneCurrentUser.id;

        // validate input
        switch (type) {
            case 'mailAddress':
                errors = validatedEmail(inputValue, currentAddList, currentUserList, userId);
                errorsRow.mailAddress = errors;  
                break;
            case 'firstName':
                errors = validatedNameUser(inputValue);
                errorsRow.firstName = errors;
                break;
            case 'lastName':
                errors = validatedNameUser(inputValue);
                errorsRow.lastName = errors;
                break;
            default:
                break;
        }
        cloneCurrentUser[type] = inputValue;

        setError(errorsRow);
        setCurrentUser(cloneCurrentUser);
    }

    const handleChangeMainLanguage = code => {
        const cloneCurrentUser = { ...currentUser, mainLanguage: code };
        const errorsRow = { ...error, mainLanguage: code ? '' : trI18n('COMMSG014') };

        setError(errorsRow);
        setCurrentUser(cloneCurrentUser);
        updateUserAddDetail(currentIndex, cloneCurrentUser, errorsRow);
    }

    const callBackUpdateUser = () => {
        updateUserAddDetail(currentIndex, currentUser, error);
    }

  

    let errorMailAddress = '';
    if (error && error?.mailAddress) {
        errorMailAddress = error?.mailAddress;
    } else if (!Utils.isEmptyObject(errorAddList) && errorAddList.mailAddress) {
        errorMailAddress = errorAddList.mailAddress;
    }
  
    return (
        <>
            {currentUser?.id && (
                
                <TableRow key={currentUser.id}>
                {/* email */}
                <TableCell className='table-row-top'>
                    <TextField
                        style={{padding: '4px 0'}}
                        error={errorMailAddress}
                        helperText={errorMailAddress}
                        className="form-control table-row-content-middle"
                        inputProps={{ className: 'user-mailAddress' }}
                        variant="outlined"
                        id={`mailAddress-${currentUser?.id}`}
                        data-cy="add-user-input-mail"
                        placeholder={tr('ユーザーID（メールアドレス）')}
                        value={currentUser.mailAddress}
                        onChange={e => handleOnChange(e, 'mailAddress')}
                        onBlur={() => callBackUpdateUser()}
                        onClick={(e) => e.target.focus()}
                    />
                </TableCell>
                
                {/* last name */}
                <TableCell className='table-row-top'>
                    <TextField
                        style={{padding: '4px 0'}}
                        error={error && error?.lastName}
                        helperText={error && error?.lastName}
                        className="form-control table-row-content-middle"
                        variant="outlined"
                        id={`lastName-${currentUser.id}`}
                        placeholder={tr('姓')}
                        InputProps={{ className: 'user-lastName' }}
                        value={currentUser.lastName}
                        onChange={e => handleOnChange(e, 'lastName')}
                        onBlur={() => callBackUpdateUser()}
                        onClick={(e) => e.target.focus()}
                    />
                </TableCell>
                {/* firt name */}
                <TableCell className='table-row-top'>
                    <TextField
                        style={{padding: '4px 0'}}
                        error={error && error?.firstName}
                        helperText={error && error?.firstName}
                        className="form-control table-row-content-middle"
                        variant="outlined"
                        id={`firstName-${currentUser.id}`}
                        placeholder={tr('名')}
                        InputProps={{ className: 'user-firstName' }}
                        value={currentUser.firstName}
                        onChange={e => handleOnChange(e, 'firstName')}
                        onBlur={() => callBackUpdateUser()}
                        onClick={(e) => e.target.focus()}
                    />
                </TableCell>
                {/* main language */}
                <TableCell className='table-row-top'>
                    <div style={{padding: '4px 0'}}>
                        <MainLanguageAutocomplete
                            id={`mainLanguage-${currentUser.id}`}
                            value={currentUser.mainLanguage || ''}
                            onChange={handleChangeMainLanguage}
                            errorText={error?.mainLanguage || errorAddList?.mainLanguage}
                            className="form-control table-row-content-middle"
                        />
                    </div>
                </TableCell>
                <TableCell className='table-row-top'>
                </TableCell>
                {/* select type */}
                <TableCell className='table-row-top'>
                    <FormControl className="form-control--wrap form-control--hg32 table-row-content-middle">
                        <Select
                            variant="outlined"
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }}
                            value={currentUser.type}
                            disabled={false}
                            onChange={e => handleOnChange(e, 'type')}
                            onBlur={() => callBackUpdateUser()}
                        >
                            <MenuItem value={Constant.USER_TYPE.GENERAL}>{trI18n('GENERAL_USER')}</MenuItem>
                            {!Utils.isGuestUser(currentUser) && <MenuItem value={Constant.USER_TYPE.INTERNAL}>{trI18n('INTERNAL_USER')}</MenuItem>}
                        </Select>
                    </FormControl>
                </TableCell>
                {/* change admin permission */}
                <TableCell
                    className={
                        currentUser.isChangePermission !== undefined && currentUser.isChangePermission
                            ? 'background-change-permission-select table-row-top'
                            : 'table-row-top'
                    }
                >
                    <div className="switch-check table-column-status">
                        <input
                            id={`add-switch-admin-${currentUser.id}`}
                            type="checkbox"
                            value={currentUser.isChangePermission}
                            disabled={currentUser.isDisableChangeSwitch || currentUser.type === Constant.USER_TYPE.INTERNAL}
                            checked={currentUser.isChangePermission}
                        />
                        <label
                            htmlFor={`add-switch-admin-${currentUser.id}`}
                            onClick={event => {
                                if (currentUser.isDisableChangeSwitch || currentUser.type === Constant.USER_TYPE.INTERNAL) return;
                                handleSelectChangeAdminOfAddUser();
                            }}
                        />
                    </div>
                </TableCell>
                {/* remove item add user tvx */}
                <TableCell className='table-row-top'>
                    <div className="editUserGroupBtn">
                        <IconButton
                            className="erase btnDeleteUser"
                            disabled={false}
                            onClick={onDeleteOrShowModalUser}
                        >
                            <img src="/assets/image/delete-icon.svg" alt="" />
                        </IconButton>
                    </div>
                </TableCell>
               
            </TableRow>
            )}
        </>
        
    );
}
export default AddUserRow;
